<div class="mb-3 flex justify-between items-center">
  <div>
    @if (!selectionMode) {
      <button mat-flat-button class="btn-tg" (click)="startSelection()">
        Selecionar OS(s)
      </button>
    } @else {
      <div class="flex gap-2">
        <button mat-flat-button class="btn-tg-white" (click)="cancelSelection()">
          Cancelar
        </button>
        <button mat-flat-button class="btn-tg" (click)="confirmSelection()">
          Atribuir fornecedor ({{ selectedCosIds.length }})
        </button>
        <button mat-flat-button class="btn-tg" (click)="notifySelection()">
          Notificar ({{ selectedCosIds.length }})
        </button>
      </div>
    }
  </div>
  <mat-button-toggle-group
    name="pendenteFilter"
    [value]="pendenteFilter"
    (change)="changePendenteFilter($event)"
  >
    <mat-button-toggle [value]="null">Todas</mat-button-toggle>
    <mat-button-toggle [value]="true">Pendentes</mat-button-toggle>
    <mat-button-toggle [value]="false">Concluídas</mat-button-toggle>
  </mat-button-toggle-group>
</div>

<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title> Pesquisa </mat-panel-title>
    </mat-expansion-panel-header>
    <div>
      <form-search-reserva-os (responseSearch)="search($event)" />
    </div>
  </mat-expansion-panel>
</mat-accordion>

<div class="mt-6">
  @if (!loading) {
    <div>
      <table-list-reserva-compras-os
        [dataSource]="itemsList"
        [columns]="columns"
        [selectedIds]="selectedCosIds"
        (editItem)="editItem($event)"
        (copyLinkItem)="copyLinkItem($event)"
        (sendEmailItem)="sendEmailItem($event)"
        (sendToFleet)="sendToFleetItem($event)"
        (toggleSelectItem)="toggleSelectItem($event)"
        (toggleSelectAll)="toggleSelectAllItems($event)"
      />
      @if (itemsList.length > 0) {
        <mat-paginator
          [length]="numberRows"
          [pageSize]="rows"
          [pageIndex]="page - 1"
          [pageSizeOptions]="[5, 10, 20, 30]"
          (page)="onPageEvent($event)"
        >
        </mat-paginator>
      }
    </div>
  } @else {
    <div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }
</div>
